export default "__VITE_ASSET__DaEFgv4A__"